import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppAyModule } from "./app-ay/app-ay.module";
import { environment } from "@env/environment";
import * as Sentry from "@sentry/angular";
import packageInfos from "../package.json";

if (environment.production) {
	enableProdMode();
}

if (environment.sentry) {
	Sentry.init({
		dsn: environment.sentryUrl,
		environment: environment.sentryEnv,
		release: `${packageInfos.name}@${packageInfos.version}`,
	});
}

platformBrowserDynamic()
	.bootstrapModule(AppAyModule)
	.catch((err) => {
		console.error(err);
	});
